import { createSlice } from '@reduxjs/toolkit';
import { initialState } from '../../../../data/entitlement/sites/siteHistory/initialState.siteHistory.data';
import {
  getSiteHistory as getSiteHistoryAPI,
} from '../../../../apis/siteAPI';
import { handlePending, handleRejection } from '../../../../constants';
import { createAsyncThunkWrapper } from '../../../../services/common/asyncThunkWrapper';
import { ACTIONS_SITES_SITEACTIVITYDETAIL } from '../../../../constants/actionCreator';


export const getSiteHistory = createAsyncThunkWrapper(
  ACTIONS_SITES_SITEACTIVITYDETAIL.FETCH_HISTORY,
  getSiteHistoryAPI
);


const siteHistorySlice = createSlice({
  name: 'siteHistory',
  initialState,
  reducers: {
    handleReset: (state, action) => {
      state.historyData = action?.payload;
    },
  
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSiteHistory.pending, (state, action) => {
        handlePending(state, action);
        state.loading = true;
        state.historyData = [];  
        state.total = 0;
      })
      .addCase(getSiteHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.historyData = action?.payload?.siteHistory || [];
        state.total =action?.payload?.totalRecords || 0;
      })
      .addCase(getSiteHistory.rejected, (state, action) => {
        handleRejection(state, action);
        state.loading = false;
        state.historyData = [];
        state.total = 0;
      })
      

  },
});

export const {
handleReset
} = siteHistorySlice.actions;

export default siteHistorySlice.reducer;
